import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-95ff111c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navbar = _resolveComponent("navbar");

  const _component_events_block = _resolveComponent("events-block");

  const _component_van_divider = _resolveComponent("van-divider");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_switch = _resolveComponent("van-switch");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");

  const _component_van_tabbar = _resolveComponent("van-tabbar");

  const _component_van_picker = _resolveComponent("van-picker");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_i18n_t = _resolveComponent("i18n-t");

  const _component_van_tab = _resolveComponent("van-tab");

  const _component_share_ios = _resolveComponent("share-ios");

  const _component_add_ios = _resolveComponent("add-ios");

  const _component_van_tabs = _resolveComponent("van-tabs");

  const _directive_t = _resolveDirective("t");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_navbar, {
    title: _ctx.$t('app.title'),
    hint: $data.active == 'events' ? 'events' : undefined
  }, null, 8, ["title", "hint"]), _createElementVNode("div", _hoisted_1, [$data.active == 'events' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.events, v => {
    return _openBlock(), _createBlock(_component_events_block, {
      key: v,
      events: v
    }, null, 8, ["events"]);
  }), 128)) : _createCommentVNode("", true), $data.active == 'calculators' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.tools, (v, i) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: v
    }, [_createVNode(_component_van_divider, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(`home.category[${i}]`)), 1)]),
      _: 2
    }, 1024), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v, u => {
      return _openBlock(), _createBlock(_component_van_button, {
        key: u,
        block: "",
        to: u.to,
        color: u.background,
        style: _normalizeStyle(u.color ? `color: ${u.color} !important;` : '')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(`route${u.to.replaceAll('/', '.')}`)), 1)]),
        _: 2
      }, 1032, ["to", "color", "style"]);
    }), 128))])], 64);
  }), 128)) : _createCommentVNode("", true), $data.active == 'settings' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createVNode(_component_van_cell_group, {
    title: _ctx.$t('settings.mirror'),
    inset: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mirrors, v => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: v
      }, [$data.hostname != v.hostname ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 0,
        title: `${v.name} ${_ctx.$t('settings.mirror')}`,
        url: v.url,
        "is-link": ""
      }, null, 8, ["title", "url"])) : _createCommentVNode("", true)], 64);
    }), 128)), _createVNode(_component_van_cell, {
      title: "",
      label: _ctx.$t('settings.mirrorDesc')
    }, null, 8, ["label"])]),
    _: 1
  }, 8, ["title"]), _createVNode(_component_van_cell_group, {
    title: _ctx.$t('settings.cache'),
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: _ctx.$t('settings.clearLocalStorage'),
      onClick: $options.clearLocalStorage,
      "is-link": "",
      center: ""
    }, null, 8, ["title", "onClick"]), _createVNode(_component_van_cell, {
      title: "",
      label: _ctx.$t('settings.clearCacheDesc')
    }, null, 8, ["label"])]),
    _: 1
  }, 8, ["title"]), _createVNode(_component_van_cell_group, {
    title: _ctx.$t('settings.appearance'),
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: _ctx.$t(`settings.appearances[${Number($options.appearance)}]`),
      label: _ctx.$t('settings.appearanceDesc'),
      center: ""
    }, {
      "right-icon": _withCtx(() => [_createVNode(_component_van_switch, {
        modelValue: $options.appearance,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.appearance = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["title", "label"])]),
    _: 1
  }, 8, ["title"]), _createVNode(_component_van_cell_group, {
    title: _ctx.$t('settings.about'),
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: _ctx.$t('settings.version'),
      value: $data.version
    }, null, 8, ["title", "value"]), _createVNode(_component_van_cell, {
      title: _ctx.$t('settings.addtohome'),
      "is-link": "",
      onClick: _cache[1] || (_cache[1] = $event => $data.showAddToHome = true)
    }, null, 8, ["title"]), _createVNode(_component_van_cell, {
      title: _ctx.$t('route.statement'),
      "is-link": "",
      to: "/statement"
    }, null, 8, ["title"]), _createVNode(_component_van_cell, {
      title: _ctx.$t('route.changelog'),
      "is-link": "",
      to: "/changelog"
    }, null, 8, ["title"])]),
    _: 1
  }, 8, ["title"]), _ctx.$root.developerMode ? (_openBlock(), _createBlock(_component_van_cell_group, {
    key: 0,
    title: _ctx.$t('settings.developer'),
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $options.langName,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $options.langName = $event),
      "is-link": "",
      readonly: "",
      label: _ctx.$t('settings.lang'),
      onClick: _cache[3] || (_cache[3] = $event => $data.showLangPicker = true)
    }, null, 8, ["modelValue", "label"]), _createVNode(_component_van_field, {
      modelValue: _ctx.$root.server,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.$root.server = $event),
      "is-link": "",
      readonly: "",
      label: _ctx.$t('settings.server'),
      onClick: _cache[5] || (_cache[5] = $event => $data.showServerPicker = true)
    }, null, 8, ["modelValue", "label"]), _createVNode(_component_van_cell, {
      title: _ctx.$t('settings.vConsole'),
      "is-link": "",
      center: ""
    }, {
      "right-icon": _withCtx(() => [_createVNode(_component_van_switch, {
        modelValue: _ctx.$root.vConsoleOpen,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.$root.vConsoleOpen = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["title"])) : _createCommentVNode("", true), _ctx.$root.developerMode ? (_openBlock(), _createBlock(_component_van_cell_group, {
    key: 1,
    title: _ctx.$t('settings.lab'),
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: _ctx.$t('route.phone'),
      "is-link": "",
      to: "/phone"
    }, null, 8, ["title"])]),
    _: 1
  }, 8, ["title"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _createVNode(_component_van_tabbar, {
    fixed: "",
    "safe-area-inset-bottom": "",
    placeholder: "",
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.active = $event),
    onChange: $options.onActiveChange
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      name: "events",
      icon: "calendar-o"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.tabbar.events')), 1)]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      name: "calculators",
      icon: "apps-o"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.tabbar.calculators')), 1)]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      name: "settings",
      icon: "setting-o"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.tabbar.settings')), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createVNode(_component_van_popup, {
    show: $data.showLangPicker,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $data.showLangPicker = $event),
    round: "",
    position: "bottom",
    "safe-area-inset-bottom": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: $data.langs,
      onCancel: _cache[8] || (_cache[8] = $event => $data.showLangPicker = false),
      onConfirm: $options.onLangConfirm
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showServerPicker,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => $data.showServerPicker = $event),
    round: "",
    position: "bottom",
    "safe-area-inset-bottom": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: $data.servers,
      onCancel: _cache[10] || (_cache[10] = $event => $data.showServerPicker = false),
      onConfirm: $options.onServerConfirm
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showAddToHome,
    "onUpdate:show": _cache[13] || (_cache[13] = $event => $data.showAddToHome = $event),
    round: "",
    position: "bottom",
    style: {
      height: '40%'
    },
    "safe-area-inset-bottom": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("h3", null, null, 512), [[_directive_t, 'settings.addtohome']]), _withDirectives(_createElementVNode("p", null, null, 512), [[_directive_t, 'settings.addtohomeDesc']]), _createVNode(_component_van_tabs, {
      active: $data.isIos,
      "onUpdate:active": _cache[12] || (_cache[12] = $event => $data.isIos = $event),
      type: "card"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_tab, {
        title: "Android"
      }, {
        default: _withCtx(() => [_createVNode(_component_i18n_t, {
          keypath: "settings.addtohomeAndroid",
          scope: "global",
          tag: "p"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_icon, {
            name: "ellipsis",
            id: "a2h-android-icon"
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_van_tab, {
        title: "iOS"
      }, {
        default: _withCtx(() => [_createVNode(_component_i18n_t, {
          keypath: "settings.addtohomeIos",
          scope: "global",
          tag: "p"
        }, {
          share: _withCtx(() => [_createVNode(_component_share_ios, {
            height: "14",
            fill: $options.fill
          }, null, 8, ["fill"])]),
          add: _withCtx(() => [_createVNode(_component_add_ios, {
            height: "14",
            fill: $options.fill
          }, null, 8, ["fill"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["active"])])]),
    _: 1
  }, 8, ["show"])], 64);
}